import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

const CTASection = () => {
  return (
    <section className="section-padding relative overflow-hidden" data-testid="cta-section">
      <div className="absolute inset-0 bg-gradient-to-r from-[#00E676]/20 via-[#00E676]/5 to-[#6366F1]/20" />
      <div className="absolute inset-0">
        <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-[#00E676]/10 rounded-full blur-3xl" />
        <div className="absolute top-1/2 right-1/4 w-80 h-80 bg-[#6366F1]/10 rounded-full blur-3xl" />
      </div>

      <div className="container-custom relative z-10 text-center">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
          Ready to Dominate Dallas Search?
        </h2>
        <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-10">
          Join the Dallas businesses that trust Digital Media Ninja for their digital marketing success. 
          Get your free SEO & AEO audit today.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to="/contact">
            <Button className="btn-ninja px-10 py-6 text-lg" data-testid="cta-audit-btn">
              Get Your Free Audit
              <ArrowRight className="w-5 h-5 ml-2" />
            </Button>
          </Link>
          <a href="tel:+14329349470">
            <Button className="btn-outline px-10 py-6 text-lg" data-testid="cta-call-btn">
              Call (432) 934-9470
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
